import api from '@/apis/di/stateBankAPI.js';
import {usefilterActionCombo} from './filterActionCombo.js';
import {getCurrentInstance} from 'vue';
import indexedDB from '@/commons/indexedDB';

// Combo grid ngân hàng
export const useStateBankComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const {proxy} = getCurrentInstance();
  const {extendFilter} = usefilterActionCombo();
  // func call api lấy dữ liệu combo
  const onStateBankComboboxLoadData = (payload, row, column) => {
    let ors = [{Field: 'inactive', Operator: 'NULL'}];
    let extend = [{Field: 'inactive', Value: false, Ors: ors}];
    payload.filter = extendFilter(payload.filter, extend);
    payload.sort = 'state_bank_code';
    if (payload.columns && !payload.columns.includes('state_bank_name')) {
      payload.columns += ',state_bank_name';
    }
    if (payload.columns && !payload.columns.includes('inactive')) {
      payload.columns += ',inactive';
    }
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const stateBankComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã ngân hàng',
        dataField: 'state_bank_code',
        width: 120,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên ngân hàng',
        dataField: 'state_bank_name',
        width: 480,
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
      },
    ],
    displayField: 'state_bank_code',
    valueField: 'state_bank_code',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onStateBankComboboxLoadData,
    rules: [],
  };

  return {
    stateBankComboConfig,
    onStateBankComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
